import { CardSec , AboutCard , Login , Footer ,  FAQ } from "../First"

export function Home() {

    return(

        <>


      <CardSec />
      <AboutCard />
      <Login />
      <FAQ />
      <Footer />

        </>
    )
}
